import { render, staticRenderFns } from "./ReturnPartsSideMenu.vue?vue&type=template&id=9575ed7c"
import script from "./ReturnPartsSideMenu.vue?vue&type=script&lang=js"
export * from "./ReturnPartsSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports